<div class="workflows-settings">
  <h1>{{ 'SETTINGS.WORKFLOWS.TITLE' | translate }}</h1>

  <div class="actions">
    <orbit-button
      [icon]="faPlus"
      label="{{ 'SETTINGS.WORKFLOWS.ADD_WORKFLOW' | translate }}"
      (click)="addWorkflow()"></orbit-button>
  </div>

  <!-- Loading indicator -->
  @if (loading()) {
    <div class="loading-container">
      <p>{{ 'SETTINGS.WORKFLOWS.LOADING' | translate }}</p>
    </div>
  }

  <!-- Error message -->
  @if (error()) {
    <div class="error-container">
      <p class="error-message">{{ error() }}</p>
    </div>
  }

  @let workflowsValue = workflows();
  <!-- Workflows table -->
  @let loadingValue = loading();
  @let errorValue = error();
  @if (!loadingValue && !errorValue && workflowsValue && workflowsValue.length > 0) {
    <div class="workflows-table-container">
      <table class="workflows-table">
        <thead>
          <tr>
            <th>{{ 'SETTINGS.WORKFLOWS.ID' | translate }}</th>
            <th>{{ 'SETTINGS.WORKFLOWS.CONVERSATION_TYPE' | translate }}</th>
            <th>{{ 'SETTINGS.WORKFLOWS.TRIGGER' | translate }}</th>
            <th>{{ 'SETTINGS.WORKFLOWS.ACTION' | translate }}</th>
            <th>{{ 'SETTINGS.WORKFLOWS.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (workflow of workflowsValue; track workflow.id) {
            <tr [class.disabled-workflow]="!workflow.enabled">
              <td>{{ workflow.id }}</td>
              <td>{{ workflow.conversationTypeId || '-' }}</td>
              <td>{{ getTriggerName(workflow.trigger) }}</td>
              <td>{{ getActionName(workflow.trigger.action) }}</td>
              <td class="actions-cell">
                <div class="actions-container">
                  <label class="switch">
                    <input
                      type="checkbox"
                      [checked]="workflow.enabled"
                      (change)="toggleWorkflowEnabled(workflow, $event)"
                      [attr.aria-label]="'SETTINGS.WORKFLOWS.TOGGLE_ENABLED' | translate" />
                    <span class="slider round"></span>
                  </label>
                  <button
                    class="btn-icon"
                    title="{{ 'SETTINGS.WORKFLOWS.EDIT_WORKFLOW' | translate }}"
                    (click)="editWorkflow(workflow)">
                    <fa-icon [icon]="faEdit" class="edit-icon"></fa-icon>
                  </button>
                  <button
                    class="btn-icon"
                    title="{{ 'SETTINGS.WORKFLOWS.DELETE' | translate }}"
                    (click)="deleteWorkflow(workflow)">
                    <fa-icon [icon]="faTrash" class="delete-icon"></fa-icon>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- No workflows message -->
  @if (!loadingValue && !errorValue && workflowsValue && workflowsValue.length === 0) {
    <div class="empty-state">
      <p>{{ 'SETTINGS.WORKFLOWS.NO_WORKFLOWS' | translate }}</p>
    </div>
  }
</div>
